import QRCode from 'qrcode'

/** Where a pending code waits between "scanned the link" and "finished signup". */
export const PENDING_INVITE_KEY = 'beseter.pendingInvite'

export const buildInviteUrl = (code) => `${window.location.origin}/i/${code}`

/**
 * Hands the link to whatever the inviter already has open — Messages,
 * WhatsApp, AirDrop — rather than the app sending anything itself. Falls back
 * to the clipboard on a browser with no share sheet (most desktops).
 */
export async function shareInvite({ url, text }) {
  if (navigator.share) {
    try {
      await navigator.share({ text, url })
      return 'shared'
    } catch (e) {
      if (e?.name === 'AbortError') return 'cancelled'
      // Fall through to clipboard on anything else — some browsers advertise
      // navigator.share and then refuse a particular payload.
    }
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(`${text}\n${url}`)
    return 'copied'
  }
  return 'unsupported'
}

/** Generated client-side — no network round trip, so it works over the
 *  inviter's own connection even if the app's isn't reachable. */
export const qrDataUrl = (text) =>
  QRCode.toDataURL(text, { margin: 1, width: 320 })
